import styled from 'styled-components/macro';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextStylesCommon } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const RichTextContainerStyled = styled.div `
  p {
    ${getTextStyles('Ubuntu', null, 16, 24)}
    ${RegularTextStylesCommon}

    color: ${colorCoreBlack300};
  }
`;
